export {
  CALLBACKS_PRODUCTION_URL,
  OIDC_IMPERSONATE_STOP_PATH,
  OIDC_LOGOUT_PATH,
} from '@buffer-mono/shared-utils/oidcAuth'

// Mirrors `entities/src/oidc/constants.ts`, so the frontend does not import the
// `@buffer-mono/entities` data layer.
export const OIDC_DOOR_PATH = '/auth/oidc/door'

export const MIGRATE_ATTEMPT_COOKIE = 'auth_migrate_attempt'
export const MIGRATE_ATTEMPT_COOKIE_ROOT_DOMAIN = 'buffer.com'
export const MIGRATE_ATTEMPT_LIMIT = 2
export const MIGRATE_ATTEMPT_COOKIE_MAX_AGE_SECONDS = 600
